import {
  VerificationIcon_default
} from "./chunk-BP4IWGGC.mjs";
export {
  VerificationIcon_default as default
};
